export default class BasketIcon {
    constructor(svg) {
        this.svg = svg
        this.text = this.svg.querySelector('text')
    }

    setValue(value, initial = false) {
        if (!value) {
            this.text.style.display = 'none'
            this.svg.parentNode.classList.add('empty')
        } else {
            this.text.querySelector('tspan tspan').innerHTML = value

            this.svg.parentNode.classList.remove('empty')
            this.text.style.display = 'block'
        }

        if (value && !initial) {
            this.svg.parentNode.classList.add('animated')

            setTimeout(() => this.svg.parentNode.classList.remove('animated'), 700)
        }
    }
}
